import _ from "lodash";

export const DATA_LIMIT = 10;

export const PRINTFUL_DASHBOARD_TABS_LIST = [
    {key: 'stores', label: 'Stores'},
    {key: 'productTypes', label: 'Product Types'},
    {key: 'categories', label: 'Categories'},
    {key: 'products', label: 'Products'},
    {key: 'productVariants', label: 'Product Variants'},
    {key: 'productsPrice', label: 'Products Price'},
    {key: 'syncProducts', label: 'Sync Products'},
    {key: 'syncProductsVariants', label: 'Sync Products Variants'},
    {key: 'syncProductsPrice', label: 'Sync Products Price'},
    {key: 'productsSync', label: 'Products Sync'},
    {key: 'syncProductsSync', label: 'Sync Products Sync'},
];


// export const DEFAULT_PRINTFUL_DASHBOARD_TAB = {key: 'categories', label: 'Categories'};
export const DEFAULT_PRINTFUL_DASHBOARD_TAB = {key: 'stores', label: 'Stores'};

export const SYNC_PRINTFUL_DASHBOARD_TABS_LIST = [
    {key: 'stores', label: 'Stores'},
    {key: 'productTypes', label: 'Product Types'},
    {key: 'categories', label: 'Categories'},
    {key: 'products', label: 'Products'},
    {key: 'productVariants', label: 'Product Variants'},
];
